import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import {
  createSubCategory,
  editSubCategory,
  getSubCategoriesByPage
} from '../../ApiServices/SubCategoriesService';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null
};

const subCategorySlice = createSlice({
  name: 'subCategory',
  initialState: initialState,
  reducers: {
    clearSubCategoryState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchSubCategories.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
    });
  }
});

export const subCategoryState = (state: RootState) => state?.subCategory;
export const { clearSubCategoryState } = subCategorySlice.actions;
export default subCategorySlice.reducer;

export const fetchSubCategories = createAsyncThunk(
  'subCategory/fetchSubCategories',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SUBCATEGORIES') }));
      return fulfillWithValue(await getSubCategoriesByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addSubCategory = createAsyncThunk(
  'subCategory/addSubCategory',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_SUB_CATEGORY_DETAILS') }));
      let response = await createSubCategory(payload);
      return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const modifySubCategory = createAsyncThunk(
  'subCategory/modifySubCategory',
  async (payload: any, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      dispatch(showLoader({ message: t('UPDATING_SUBCATEGORIES_DETAILS') }));
      let response = await editSubCategory(payload);
      return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
